import { render } from "./AppFooter.vue?vue&type=template&id=94268e82"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"
script.render = render

export default script